import { render } from "./Navigation.vue?vue&type=template&id=17c9e1fc"
import script from "./Navigation.vue?vue&type=script&setup=true&lang=js"
export * from "./Navigation.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/components/Navigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17c9e1fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17c9e1fc', __exports__)) {
    console.log('reload')
    api.reload('17c9e1fc', __exports__)
  }
  
  module.hot.accept("./Navigation.vue?vue&type=template&id=17c9e1fc", () => {
    console.log('re-render')
    api.rerender('17c9e1fc', render)
  })

}


export default __exports__